import * as Sentry from "@sentry/react";
export var setSentryUser = function(userId) {
    if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === "1") {
        Sentry.setUser({
            id: userId
        });
    }
};
